import React, { useEffect, useRef, useState } from 'react';
import { classInfo } from '../data';
import { checkBirthdayPriority } from '../services/birthdayService';
import '../styles/birthday.css';

const LoginCard = ({ password, setPassword, loginError, handleLogin, theme }) => {
  const audioRef = useRef(null);
  const [isMuted, setIsMuted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    handleLogin();
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleLogin();
    }
  };

  // Doğum günü kontrolü
  const birthdayCheck = checkBirthdayPriority();
  const isBirthdayTheme = birthdayCheck.hasBirthday;

  // Doğum günü müziği
  useEffect(() => {
    if (isBirthdayTheme && audioRef.current) {
      audioRef.current.volume = 0.3; // Düşük ses
      audioRef.current.play().catch(e => console.log('Audio play failed:', e));
    }
    
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
    };
  }, [isBirthdayTheme]);

  const toggleMute = () => {
    if (audioRef.current) {
      if (isMuted) {
        audioRef.current.volume = 0.3;
        audioRef.current.play();
      } else {
        audioRef.current.pause();
      }
      setIsMuted(!isMuted);
    }
  };

  const cardStyle = theme && theme.colors ? {
    background: `linear-gradient(180deg, ${theme.colors.secondary}40, ${theme.colors.primary}20)`,
    border: `2px solid ${theme.colors.primary}60`
  } : {};

  const buttonStyle = theme && theme.colors ? {
    background: `linear-gradient(45deg, ${theme.colors.primary}, ${theme.colors.secondary})`,
    borderColor: theme.colors.secondary
  } : {};



  return (
    <div className={`login-card ${isBirthdayTheme ? 'birthday-mode' : ''}`} style={{...cardStyle, position: 'relative', overflow: 'hidden'}}>

      
      <div className="login-header" style={{position: 'relative', zIndex: 2}}>
        {/* Doğum günü temasında başlığı gizle */}
        <h1 
          className="school-title" 
          style={{
            display: isBirthdayTheme ? 'none' : 'block'
          }}
        >
          🌟 PARLAYAN YILDIZLAR AKADEMİSİ
        </h1>
        
        {/* Doğum günü avatarı */}
        {isBirthdayTheme && birthdayCheck.birthdayStudent && (
          <div className="birthday-avatar-container">
            <div className="birthday-avatar-wrapper">
              <img 
                src={birthdayCheck.birthdayStudent.avatar} 
                alt={birthdayCheck.birthdayStudent.name}
                className="birthday-avatar"
              />
            </div>
          </div>
        )}
        
        {/* Müzik kontrol butonu */}
        {isBirthdayTheme && (
          <button 
            onClick={toggleMute}
            className="music-control-btn"
            type="button"
            aria-label={isMuted ? 'Müziği aç' : 'Müziği kapat'}
          >
            {isMuted ? '🔇' : '🎵'}
          </button>
        )}
        
        <h2 className="school-name">{classInfo.school}</h2>
        <h3 className="class-name">{classInfo.className}</h3>
        <div className="teacher-info">
          <span className="teacher-label">Öğretmeniniz</span>
          <span className="teacher-name">{classInfo.teacher}</span>
          <div className="teacher-divider">────────── ✦ ──────────</div>
        </div>
      </div>
      
      <form className="login-form" onSubmit={handleSubmit} style={{position: 'relative', zIndex: 2}}>
        <input
          type="text"
          name="username"
          value="teacher"
          autoComplete="username"
          style={{display: 'none'}}
          readOnly
        />
        <input
          type="password"
          placeholder="🔐 Şifre giriniz"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={handleKeyDown}
          className="login-input"
          autoComplete="current-password"
          aria-label="Şifre girişi"
        />
        {loginError && <p className="error-message">{loginError}</p>}
        <button 
          type="submit"
          className="login-button"
          style={buttonStyle}
          role="button"
          aria-label="Şifre ile giriş"
        >
          {theme?.icon || '🌸'} ÖĞRETMENİM GİRİŞİ
        </button>
      </form>
      
      {/* Doğum günü müziği */}
      {isBirthdayTheme && (
        <audio 
          ref={audioRef}
          loop
          preload="auto"
        >
          <source src="/sounds/birthday-song.mp3" type="audio/mpeg" />
          <source src="/sounds/birthday-song.ogg" type="audio/ogg" />
        </audio>
      )}
    </div>
  );
};

export default LoginCard;